import { buildPairExclusion } from "@synapse/engine";
import type { GraphData } from "../types/gameTypes";
import { findValidWordPair } from "./gameLogic";

export { buildPairExclusion, pairKey } from "@synapse/engine";

type Pair = { startWord: string; targetWord: string };

/**
 * Pick a random-game pair the player has not played, and never today's daily.
 * If excluding history leaves no valid pair, fall back to excluding only the
 * daily: a repeat is better than failing to start a game.
 *
 * Only for player-facing random games. Dailies are chosen per date by
 * challengeSelector and must never depend on a player's history.
 */
export function pickUnplayedPair(
  graphData: GraphData | null,
  history: readonly Pair[],
  todaysDaily: Pair | null | undefined,
  opts: { rng?: () => number; par?: number } = {},
): { start: string | null; end: string | null } {
  const dailyOnly = buildPairExclusion([], todaysDaily);
  const exclude = buildPairExclusion(history, todaysDaily);
  const { rng, par } = opts;
  const pair = findValidWordPair(graphData, { rng, par, exclude });
  if ((pair.start && pair.end) || exclude.size === dailyOnly.size) {
    return pair;
  }
  return findValidWordPair(graphData, { rng, par, exclude: dailyOnly });
}
